import { Route, Redirect } from "react-router";

const PublicRoute = ({ component: Component, setIsAuthed, restricted, isAuthed, ...rest }) => {
  return (
    (restricted && isAuthed) ? <Redirect to='/home' {...rest} /> : <Route {...rest} render={props => (
      <Component {...props} setIsAuthed={setIsAuthed} />
    )} />
  );
};

export default PublicRoute;